import { createFileRoute, Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex items-center justify-center bg-background text-foreground">
      <div className="text-center space-y-4 p-8">
        <h1 className="text-6xl font-bold text-primary">404</h1>
        <p className="text-xl text-muted-foreground">{t('common.notFound')}</p>
        <Link
          to="/"
          className="inline-block px-4 py-2 bg-primary text-primary-foreground rounded-md hover:opacity-90"
        >
          {t('common.backToHome')}
        </Link>
      </div>
    </div>
  );
}

export const Route = createFileRoute('/not-found')({
  component: NotFoundPage,
});
